/**
 * @file ラジオボタンによる表示切り替え
 *
 */
'use strict'

import Common from "../../Utils/Common"

/**
 * @classname ChangeDisplayByRadioButton
 * @classdesc ラジオボタンによる表示切り替え
 */
export default class ChangeDisplayByRadioButton {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.change-display-group')
	 */
	constructor($e) {
		console.log('ChangeDisplayByRadioButton.constructor')
		this._$e = $e
		this._$defaultShowTarget = $(this._$e.data('default-show-target'))
		this._$radioButtons = this._$e.find('input')
		this._$radioButtons.on('change', () => this.onChange())
		this.onChange(false)
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof ChangeDisplayByRadioButton
	 * @return {undefined}
	 */
	onChange(resetValue = true) {
		console.log('ChangeDisplayByRadioButton.onChange')
		this._$radioButtons.each((idx, e) => Common.addIgnoreValidate($($(e).data('show-target')), resetValue))
		$(this._$e.find('input:checked').data('show-target')).each((idx, e) => {
			$(e)
				.show()
				.find('.error-tip')
				.removeClass('show')
				.find('.error-tip-inner')
				.text('')
			$(e)
				.find('.validate')
				.removeClass('ignore-validate')
		})
	}
}
